/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { RECEIVED_UPDATE_WORKSPACE_PREFERENCES } from 'state/Actions';
import { addToast } from 'state/toast/ToastActions';
import {
  analyticsActionError,
  analyticsActionSuccess
} from 'state/analytics/AnalyticsActions';

const UpdateWorkspacePreferencesLogic = createLogic({
  type: RECEIVED_UPDATE_WORKSPACE_PREFERENCES,

  process({ action }, dispatch, done) {
    const { preferences } = action;
    const { defaultGroupBy } = preferences;

    if (defaultGroupBy) {
      const defaultGroupByError =
        defaultGroupBy.disposition &&
        defaultGroupBy.disposition.result === false;
      if (!defaultGroupByError) {
        dispatch(addToast(true, 'Changes Saved'));
        dispatch(
          analyticsActionSuccess('ProfPref', 'UpdateAccountViewSettings')
        );
      } else {
        const title = '';
        const message =
          'Unfortunately, we were unable to save the changes to your account view settings due to an error in our processes. Please try again later.'
        dispatch(addToast(false, title, message));
        dispatch(analyticsActionError('UpdateAccountViewSettings'));
      }
    }
    done();
  }
});

export default UpdateWorkspacePreferencesLogic;
